import React, { Component } from "react";
import { Modal, Form, Row, Col, Button } from "antd";
import InputForm from "./InputForm";
import "./Form.css";
import { validateEmail, validateSenha, checkFormIsValid, CPFValido } from "../utils/Validator";
import { maskCPF, maskTelefone } from "../utils/Masker";
import axios from "axios";
import UsuarioFrame from './UsuarioFrame';

const { Item: ItemForm } = Form;

export default class UsuarioEmpForm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      registro: {
        usu_cpf: { key: '0' },
      },
    }
  }

  componentDidMount() {

  }

  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        registro: this.props.registroSelecionado,
      }, () => {
        // this.refs.usu_cpf.focus();
      });
    }
  }

  onChangeUsuario = event => {
    const { registro } = this.state;
    registro['usu_cpf'] = event.usu_cpf;
    this.setState(event);
  }




  onOK = () => {
    const { registro } = this.state;

    if ((!this.state.registro.usu_cpf) || (this.state.registro.usu_cpf.key === '0') || (this.state.registro.usu_cpf.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Selecione o Usuário', });
      return;
    }

    const reg = {
      ue_empresa: 0,
      ue_usuario: this.state.usu_cpf.key,
    };

    // console.log('onOK: ', reg)

    this.props.onSalvarUsuEmpClick(reg);
  };



  render() {
    const { onCancelarUsuEmpClick, carregando, visivel } = this.props;
    const { usu_cpf } = this.state.registro;

    return (
      <Modal
        title={"Incluir Usuário Cadastrado nessa Empresa"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarUsuEmpClick}
        footer={null}
        width={"40%"}
        style={{ top: 30 }}
      >
        <Form>
          <Row>

            <Col xs={24} style={{ paddingRight: 20, }}>
              <UsuarioFrame
                label="Usuário"
                id="usu_cpf"
                value={usu_cpf}
                width={"100%"}
                // vendedor={1}
                todasEmpresas={0}
                onChange={this.onChangeUsuario}
                descricaoPrimeiroItem="Selecione um Usuário"
              />
            </Col>

          </Row>

          <ItemForm>
            <Row>
              <Col xs={24}>
                 <Button
                  htmlType="button"
                  loading={carregando}
                  onClick={this.onOK}
                  className="botoesModalForm"
                >
                  Salvar
                </Button>

                <Button
                  htmlType="button"
                  onClick={onCancelarUsuEmpClick}
                  className="botoesModalFecharForm"
                >
                  Cancelar
                </Button>
              </Col>
            </Row>
          </ItemForm>

        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/UsuarioEmpForm.js